import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCrm from '../../reducers/crm/crm.reducer';

export const selectCRMOffersFeature = createFeatureSelector<
  fromCrm.State
>(fromCrm.crmFeatureKey);

// INTERFACES
export interface CrmModel {
  offers: any;
  selectedCRMOffer: any;
}

// SELECTORS
export const selectCRMOffers = createSelector(
  selectCRMOffersFeature,
  (state: fromCrm.State): CrmModel => {
    return {
      offers: state.offers,
      selectedCRMOffer: state.selectedCRMOffer
    };
  }
);
